// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
import { select2RemoteAjax } from './select2_remote';

(function() {

$(document).on("turbo:load", () => $('#contact_label_contact_ids').select2(ajax_select));
const ajax_select = {
  language: "ja",
  placeholder: "連絡先検索",
  allowClear: true,
  multiple: true,
  ajax: select2RemoteAjax({
    url: "/contacts.json",
    query: params => ({ search_text_cont_all: params.term })
  }),
  escapeMarkup(markup) { return markup; }, // let our custom formatter work
  minimumInputLength: 1
};

})();
